import { useQuery } from "@apollo/client"
import CustomCard from "components/Atoms/CustomCard"
import { get } from "lodash-es"
import React, { useState } from "react"
import ReactTable from "react-table"
import StyledLink from "components/Atoms/StyledLink"
import Actions from "components/Common/Actions"
import AlertDialogue from "components/Common/AlertDialogue"
import Error from "components/Common/Error"
import ReactTableHeader from "components/Common/ReactTableHeader"
import NewResourceButton from "components/Organisms/AddResourceButton"
import SerialColumn from "components/Organisms/table/SerialColumn"
import { DELETE_GROUP, GROUP_LIST } from "graphql/group.graphql.gql"
import GroupPermissions from "./GroupPermissions"
import GroupRegistration from "./GroupRegistration"

export default function Groups() {
  const [id, setId] = useState("")
  const [modalOpen, setModal] = useState(false)
  const [alertVisible, setAlert] = useState(false)

  const COLUMNS = [
    SerialColumn,
    {
      accessor: "actions",
      maxWidth: 50,

      Cell({ original }) {
        return (
          <Actions
            item={{ id: original.id }}
            actions={[
              { name: "Edit group", handler: handleEdit, icon: "edit" },
              {
                name: "Archive group",
                handler: handleDelete,
                icon: "projects",
              },
            ]}
          />
        )
      },
    },
    {
      Header: "Name",
      accessor: "name",
      width: 175,
    },
    {
      Header: "No. People",
      accessor: "userCount",
      width: 100,
      Cell({ original, value }) {
        return (
          <StyledLink
            to={{
              pathname: "/d/registration/user",
              search: `?group=${original.name}&page=0`,
            }}
          >
            {value}
          </StyledLink>
        )
      },
    },
    {
      Header: "Permissions",
      accessor: "permissions.name",

      Cell({ original }) {
        return (
          <span>
            <GroupPermissions items={original.permissions} />
          </span>
        )
      },
    },
  ]
  function handleNewGroup() {
    setId("")
    setModal(true)
  }
  function handleEdit(id) {
    setId(id)
    setModal(true)
  }
  function handleDelete(id) {
    setId(id)
    setAlert(true)
  }
  const { data, loading, error } = useQuery(GROUP_LIST)

  if (error) return <Error />
  return (
    <CustomCard className="p-0">
      <ReactTableHeader icon="people" title="Groups">
        <NewResourceButton
          module="group"
          id="vt_add_group_button"
          onClick={handleNewGroup}
        />
      </ReactTableHeader>

      <ReactTable
        pageSize={data?.allGroups?.length > 20 ? data?.allGroups?.length : 20}
        loading={loading}
        showPagination={false}
        className="mt-0 vt-groups-list vt-master-table"
        data={data && data.allGroups}
        columns={COLUMNS}
      />

      <GroupRegistration
        id={id}
        isOpen={modalOpen}
        onClose={e => setModal(false)}
      />
      <AlertDialogue
        alertFor="Group"
        isOpen={alertVisible}
        onClose={e => setAlert(false)}
        mutation={DELETE_GROUP}
        update={(cache, result) => {
          const deletedGroup = get(result, "data.delGroup.groupId")

          const { allGroups } = cache.readQuery({
            query: GROUP_LIST,
          })

          cache.writeQuery({
            query: GROUP_LIST,
            data: {
              allGroups: allGroups.filter(
                g => parseInt(g.id) !== parseInt(deletedGroup)
              ),
            },
          })
        }}
        variables={{
          id,
        }}
      />
    </CustomCard>
  )
}
